import { NamedIconsType } from '@europrocurement/l2d-icons/types';
import {
    faAdd,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faEdit,
    faEye,
    faLink,
    faPaperPlane,
    faPlusCircle,
    faSearch,
    faUser,
    faUserSlash,
    faRotateRight,
    faHammer,
    faClipboard,
    faClipboardCheck,
    faCamera,
    faMessageQuestion,
    faHome,
} from '@fortawesome/sharp-regular-svg-icons';

export const assistanceIcon: NamedIconsType = {
    props: { icon: faMessageQuestion },
    name: 'assistance',
    displayName: 'Assistance',
};

export const createIcon: NamedIconsType = {
    props: { icon: faAdd },
    name: 'create',
    displayName: 'create',
};

export const updateIcon: NamedIconsType = {
    props: { icon: faEdit },
    name: 'update',
    displayName: 'update',
};

export const addIcon: NamedIconsType = {
    props: { icon: faPlusCircle },
    name: 'add',
    displayName: 'Ajouter',
};

export const associateIcon: NamedIconsType = {
    props: { icon: faLink },
    name: 'associate',
    displayName: 'Associer',
};

export const sendIcon: NamedIconsType = {
    props: { icon: faPaperPlane },
    name: 'send',
    displayName: 'Envoyer',
};

export const searchIcon: NamedIconsType = {
    props: { icon: faSearch },
    name: 'search',
    displayName: 'search',
};

export const clearIcon: NamedIconsType = {
    props: { icon: faUser },
    name: 'clear',
    displayName: 'clear',
};

export const profilePictureUpdateIcon: NamedIconsType = {
    props: { icon: faCamera },
    name: 'profilePictureUpdate',
    displayName: 'Modifier la photo de profil',
};

export const removeUserIcon: NamedIconsType = {
    props: { icon: faUserSlash },
    name: 'removeUser',
    displayName: 'removeUser',
};

export const buildDataIcon: NamedIconsType = {
    props: { icon: faHammer },
    name: 'buildData',
    displayName: 'Construire',
};

export const homeIcon: NamedIconsType = {
    props: { icon: faHome },
    name: 'home',
    displayName: 'Accueil',
};

export const refreshDataIcon: NamedIconsType = {
    props: { icon: faRotateRight },
    name: 'refreshData',
    displayName: 'Rafraîchir la donnée',
};

export const refreshIcon: NamedIconsType = {
    props: { icon: faUser },
    name: 'refresh',
    displayName: 'refresh',
};

export const previewIcon: NamedIconsType = {
    props: {
        icon: faEye,
    },
    name: 'preview',
    displayName: 'preview',
};

export const downIcon: NamedIconsType = {
    props: { icon: faChevronDown },
    name: 'down',
    displayName: 'down',
};

export const upIcon: NamedIconsType = {
    props: { icon: faChevronUp },
    name: 'up',
    displayName: 'up',
};

export const rightIcon: NamedIconsType = {
    props: { icon: faChevronRight },
    name: 'right',
    displayName: 'right',
};

export const leftIcon: NamedIconsType = {
    props: { icon: faChevronLeft },
    name: 'left',
    displayName: 'left',
};

export const copyIcon: NamedIconsType = {
    props: { icon: faClipboard },
    name: 'copy',
    displayName: 'copy',
};

export const copiedIcon: NamedIconsType = {
    props: { icon: faClipboardCheck },
    name: 'copied',
    displayName: 'copied',
};

export const userActionIcons: NamedIconsType[] = [
    assistanceIcon,
    createIcon,
    updateIcon,
    searchIcon,
    clearIcon,
    refreshIcon,
    previewIcon,
    downIcon,
    upIcon,
    rightIcon,
    leftIcon,
    copyIcon,
    copiedIcon,
    removeUserIcon,
    profilePictureUpdateIcon,
];
